import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import {
    CurrentRideContract,
    CurrentRideVinRequestContract,
} from '@polaris-customerweb/sharedcomponents.core';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InProgressRideResourceService {
    baseUrl: string;

    constructor(
        configService: ConfigService,
        private routingHelpersService: RoutingHelpersService,
        private http: HttpClient
    ) {
        this.baseUrl = routingHelpersService.combineUrl(
            configService.apiUrl.connectedVehicle,
            'api/v1/rides/'
        );
    }

    getInProgressRides(
        requestData: CurrentRideVinRequestContract[]
    ): Observable<CurrentRideContract[]> {
        const url = this.routingHelpersService.combineUrl(
            this.baseUrl,
            'current'
        );
        return this.http.post<CurrentRideContract[]>(url, requestData);
    }

    saveInProgressRide(vin: string): Observable<void> {
        const url = this.routingHelpersService.combineUrl(
            this.baseUrl,
            vin,
            'complete'
        );
        return this.http.post<undefined>(url, {});
    }

    discardInProgressRide(vin: string): Observable<void> {
        const url = this.routingHelpersService.combineUrl(
            this.baseUrl,
            vin,
            'discard'
        );
        return this.http.delete<undefined>(url);
    }
}
